import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { FolderIcon, FolderOpenIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FOLDER_TAB_WIDTH = 120;
export const StyledFolderTabContent = styled.div.withConfig({
  displayName: "ViewFoldersTab__StyledFolderTabContent",
  componentId: "sc-1femqhu-0"
})(({
  $active,
  theme: {
    borderWidth,
    color,
    space
  }
}) => `
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${space['200']};

  background-color: ${$active ? color['fill-surface-default'] : color['fill-tertiary-hover']};
  border-bottom: ${borderWidth['100']} solid${$active ? 'transparent' : color['border-tertiary-default']};
  border-left: ${borderWidth['100']} solid ${color['border-tertiary-default']};
  border-right: ${borderWidth['100']} solid ${color['border-tertiary-default']};
  border-top: ${borderWidth['100']} solid ${color['border-tertiary-default']};
  cursor: pointer;
  height: 39px;
  padding: 0 ${space['400']};
  position: relative;
  top: 1px;
`);
const sharedIconProps = {
  color: 'icon-tertiary-default',
  size: '400'
};
export function ViewFoldersTabV2({
  isFoldersMode,
  onTabClick
}) {
  return /*#__PURE__*/_jsx(Box, {
    grow: 0,
    shrink: 1,
    basis: "auto",
    marginInlineStart: "1100",
    minInlineSize: `${FOLDER_TAB_WIDTH}px`,
    inlineSize: `${FOLDER_TAB_WIDTH}px`,
    children: /*#__PURE__*/_jsxs(StyledFolderTabContent, {
      $active: isFoldersMode,
      "data-tab-pinned": "true",
      "data-test-id": "crm-listing-folder-tab",
      "data-view-id": "folders",
      onClick: onTabClick,
      children: [isFoldersMode ? /*#__PURE__*/_jsx(FolderOpenIcon, Object.assign({}, sharedIconProps)) : /*#__PURE__*/_jsx(FolderIcon, Object.assign({}, sharedIconProps)), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.viewTabs.folders"
      })]
    })
  });
}
export default ViewFoldersTabV2;